﻿import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom'
import 'components/navigation/Navigation.css';

export function InternalLink(props) {

    return (
        <NavLink to={props.link} end>{props.children}</NavLink>
    );

}

InternalLink.propTypes = {
    link: PropTypes.string.isRequired
}